import { z } from 'zod'

export const radarSearchSchema = z.object({
  tab: z.enum(['matches', 'props', 'completed']).optional().default('matches'),
  status: z.enum(['active', 'completed']).optional().default('active'),
  search: z.string().optional(),
  sort: z.enum(['default', 'price-gap', 'activity', 'recently-finished']).optional().default('default'),
  filter: z.enum(['price-gap', 'large-fund', 'trading-activity']).optional(),
  competitionCode: z.string().trim().min(1).optional(),
  season: z.coerce.number().int().positive().optional(),
})

export type RadarSearch = Omit<z.input<typeof radarSearchSchema>, 'season'> & {
  season?: number
}

export function parseRadarSearch(search: unknown): RadarSearch {
  return radarSearchSchema.parse(search)
}
